export default __webpack_public_path__ + "static/media/013-perfume.ca83bd5f.svg";